export const breakLineTag = "<br />";
export const whatsAppBreakLineTag = "%0a";
export const textAppBreakLineTag = "\n";